module.exports = __webpack_public_path__ + "img/wechatpay.4b128cc5.png";